import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { useContext } from 'react';
import { Action, ActionHandlerParams } from '../utils/types';
import useService from '../utils/useService';
import useAction from '../utils/utils';

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { onDownloadCsv } = useAction(params);
	const { deleteSegment } = useService();
	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/staticSegments/create'
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/staticSegments/edit',
					state: {
						rowData
					}
				});
			};
		case 'versionHistory':
			return () => {
				history.push({
					pathname: '/dashboard/staticSegments/showVersionHistory',
					state: {
						rowData
					}
				});
			};
		case 'download':
			return () => {
				onDownloadCsv();
			};
		case 'delete': {
			const deleteStaticSegment = () => {
				return deleteSegment(rowData, showAlert);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to delete this segment?',
					handleAlertConfirmation: deleteStaticSegment
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
